export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10 max-w-4xl mx-auto text-center">
        <div className="relative w-full h-[300px] md:h-[400px] rounded-2xl overflow-hidden mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Lifestyle%20flat%20lay%20of%20curated%20fashion%20items%20including%20beige%20trench%20coat%20folded%20denim%20jeans%20brown%20leather%20loafers%20minimalist%20sunglasses%20on%20soft%20warm%20gray%20linen%20fabric%20surface%20gentle%20afternoon%20window%20light%20casting%20subtle%20shadows%20editorial%20product%20photography%20elegant%20composition%20with%20breathing%20room%20scandinavian%20minimalism%20warm%20earthy%20tones%20high%20detail%20film%20grain&width=1600&height=900&seq=cta-banner-v2&orientation=landscape"
            alt="Kakobuy Spreadsheet – pełna baza produktów"
            title="Kakobuy Spreadsheet produktowa baza"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-black/15"></div>
        </div>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
          Gotowy, aby odkryć <span className="italic text-primary-500 font-normal">najlepsze Kakobuy Finds</span>?
        </h2>
        <p className="text-base md:text-lg text-foreground-600 mt-4 max-w-2xl mx-auto leading-relaxed">
          Przejdź do <strong>Kakobuy Spreadsheet</strong> i znajdź wszystkie produkty uporządkowane w jednym miejscu. Oszczędzaj czas i porównuj ceny z łatwością.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-4 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            kakobuy sheet
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-4 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            buy it now
            <i className="ri-shopping-bag-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}